import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { addItemToCart, generateSubtotal } from '../../containers/Cart/cartSlice';

import staticGiftCards from '../../constants/staticGiftCards';
import _ from 'lodash';
import isDataEmpty from '../../helpers/isDataEmpty';
import DetailHeader from './DetailHeader';
import DetailedCardContent from './DetailedCardContent';
import SuggestionList from './SuggestionList';
import Loader from '../../helpers/Loader';
import LayoutWrapper from '../LayoutWrapper';

const GiftCardDetailDisplay = (props) => {
	const { addItemToCart, cartData, generateSubtotal, siteId, subtotal, userBalance } = props;

	const params = useParams();

	const [selectedGiftCard, setSelectedGiftCard] = React.useState();
	const [quantity, setQuantity] = React.useState(1);
	const [hasBeenAdded, setHasBeenAdded] = React.useState(false);
	const [confirmAddition, setConfirmAddition] = React.useState(false);
	const [cardsByCategory, setCardsByCategory] = React.useState();

	React.useEffect(() => {
		if (!selectedGiftCard || selectedGiftCard?.id !== params.id) {
			const filteredCard = staticGiftCards.filter((card) => card?.id === parseInt(params.id));

			setSelectedGiftCard(filteredCard[0]);
		}

		if (isDataEmpty(cardsByCategory)) {
			const filteredOptions = staticGiftCards.filter(
				(card) => card?.category === selectedGiftCard?.category
			);

			const samplePicks = _.sampleSize(filteredOptions, 3);

			setCardsByCategory(samplePicks);
		}
	}, [cardsByCategory, params]);

	React.useEffect(() => {
		if (hasBeenAdded) {
			setTimeout(() => {
				setHasBeenAdded(false);
			}, 500);
		}

		if (confirmAddition) {
			setTimeout(() => {
				setConfirmAddition(false);
			}, 4000);
		}
	}, [hasBeenAdded]);

	const handleAddToCart = () => {
		addItemToCart({ ...selectedGiftCard, quantity: quantity > 1 ? quantity : null });
		generateSubtotal();
		setHasBeenAdded(true);
		setConfirmAddition(true);
	};

	if (!selectedGiftCard) {
		return <Loader />;
	}

	return (
		<LayoutWrapper>
			<DetailHeader cartData={cartData} siteId={siteId} />
			<DetailedCardContent
				confirmAddition={confirmAddition}
				generateSubtotal={generateSubtotal}
				handleAddToCart={handleAddToCart}
				hasBeenAdded={hasBeenAdded}
				quantity={quantity}
				setQuantity={setQuantity}
				selectedGiftCard={selectedGiftCard}
				siteId={siteId}
				subtotal={subtotal}
				userBalance={userBalance}
			/>
			<SuggestionList
				addItemToCart={addItemToCart}
				cardsByCategory={cardsByCategory}
				generateSubtotal={generateSubtotal}
				siteId={siteId}
				subtotal={subtotal}
				userBalance={userBalance}
			/>
		</LayoutWrapper>
	);
};

GiftCardDetailDisplay.propTypes = {
	addItemToCart: PropTypes.func,
	cartData: PropTypes.array,
	generateSubtotal: PropTypes.func,
	siteId: PropTypes.number,
	subtotal: PropTypes.number,
	userBalance: PropTypes.object
};

const mapStateToProps = (state) => {
	return {
		cartData: state.cartSlice.cartData,
		siteId: state.authSlice.siteId,
		subtotal: state.cartSlice.subtotal,
		userBalance: state.authSlice.userBalance.data
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addItemToCart: (payload) => {
			dispatch(addItemToCart(payload));
		},
		generateSubtotal: () => {
			dispatch(generateSubtotal());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardDetailDisplay);
